import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import history from "../../history";
import { LOGIN_PAGE_ROUTE, CHANGE_BUSINESS_ROUTE } from "../../data/routes-constants";
import { useDispatch } from "react-redux";
import { userLogout } from "../../redux/slices";
import ConfirmationModal from "../../components/reusable-ui/confirmation-modal";
import { removeLocalStorage } from "../../utils";
import { AUTH_TOKEN, PERSIST_ROOT_KEY } from "../../data/local-storage-constants";
import { checkSupportLogout, getCurrentVersionText, isSupportLogin } from "../../helpers/common-helper";

const AccountControlComponent = () => {
  const [openUserInfo, setOpenUserInfo] = useState(false);
  const userData = useSelector((state: any) => state.businessReducer.userData);
  const dispatch = useDispatch();
  const isSupportLoginActive = isSupportLogin();
  const colorPallete: any = {
    admin: {
      color: "text-[#4AB412]",
      bgColor: "bg-[#4AB412]/10",
    },
    cashier: {
      color: "text-[#D38F1B]",
      bgColor: "bg-[#F5AD39]/10",
    },
    manager: {
      color: "text-[#701BD3]",
      bgColor: "bg-[#7021D3]/10",
    },
  };
  const [openLogoutPopup, setOpenLogoutPopup] = useState(false);

  useEffect(() => {
    window.addEventListener("click", function (e: any) {
      if (
        document.getElementById("user-info-box")?.contains(e.target) ||
        document.getElementById("user-info-button")?.contains(e.target)
      ) {
        // Clicked in box
      } else {
        // Clicked outside the box
        setOpenUserInfo(false);
      }
    });
  }, []);

  const onLogoutClick = () => {
    dispatch(
      userLogout({
        callback: () => {
          removeLocalStorage(AUTH_TOKEN);
          removeLocalStorage(PERSIST_ROOT_KEY);
          checkSupportLogout();
          history.push(LOGIN_PAGE_ROUTE);
        },
      }),
    );
  };
  
  const currentReleaseVersion = getCurrentVersionText();

  return (
    <>
      <div className="flex items-center relative">
        {/* {isMobileDevice() ? null : (
          <div className="flex items-center pr-[20px] border-r border-[#707070]/20 h-[42px]">
            <div className="rista-sprite ic-help mr-[6px]"></div>
            <p className="text-14 font-medium">Help/FAQs</p>
          </div>
        )} */}
        <div
          className={`flex items-center px-[10px] py-[8px] ml-[14px] hover:bg-[#D7E5FD]/30 ${openUserInfo ? "bg-[#D7E5FD]/30" : ""
            } rounded-[6px] cursor-pointer
            sm:py-[6px]
          `}
          onClick={() => setOpenUserInfo(!openUserInfo)}
          id="user-info-button"
        >
          <div
            className={`w-[38px] h-[38px] rounded-[50%] border bg-white border-[#0074FB] p-2 mr-[8px]
              sm:w-[32px] sm:h-[32px]
            `}
          >
            <p
              className={`flex items-center justify-center w-full h-full rounded-[50%] bg-[#D7E5FD]
               text-[#397EF5] text-16 font-semibold
              `}
            >
              {userData?.name?.firstName?.charAt(0) || "U"}
            </p>
          </div>
          <p className="text-14 text-black font-semibold mr-[6px]">
            {userData?.name?.firstName || "User"}
          </p>
          <div
            className={`rista-sprite ${openUserInfo ? "ic-dropdown_arrow_up3" : "ic-dropdown_arrow_down3"
              } transition-transform duration-300`}
          ></div>
        </div>
        {openUserInfo && (
          <div
            id="user-info-box"
            className="w-[200px] absolute right-0 top-[58px] border border-[#FAFAFA] bg-white shadow-cust5 rounded-[8px] pt-[16px]"
          >
            <div className="px-[20px] flex flex-col items-center">
              <div
                className={`w-[56px] h-[56px] rounded-[50%] border bg-white border-[#0074FB] p-2 mr-[8px]
                sm:w-[48px] sm:h-[48px]
              `}
              >
                <p
                  className={`flex items-center justify-center w-full h-full rounded-[50%] bg-[#D7E5FD]
                 text-[#397EF5] text-22 font-semibold
                `}
                >
                  {userData?.name?.firstName?.charAt(0) || "U"}
                </p>
              </div>
              <h1 className="text-17 font-medium mt-[4px]">
                {userData?.name?.firstName || "User"}
              </h1>
              <p className="text-12 text-black/[0.48] mt-[4px] font-normal">
                UserID: {userData?.userId || "no id"}
              </p>
              <p
                className={`${userData?.role
                    ? colorPallete[userData?.role?.toLowerCase()]?.color
                    : ""
                  } ${userData?.role
                    ? colorPallete[userData?.role?.toLowerCase()]?.bgColor
                    : ""
                  } text-10 font-medium px-[10px] py-[2px] rounded-[4px] uppercase mt-[10px]`}
              >
                {userData?.role || "No Role"}
              </p>
            </div>
            <div className={`text-12 text-black/[0.48] font-normal pt-[14px] pl-[22px] ${!isSupportLoginActive ? 'pb-[14px]' : ''}`}>Version: {currentReleaseVersion}</div>
            {isSupportLoginActive && (
              <div
                className="flex items-center w-full mt-[18px] px-[20px] py-[16px] border-t border-[#DDDDDD] hover:bg-black/5 cursor-pointer"
                onClick={() => history.push(CHANGE_BUSINESS_ROUTE)}
              >
                <div className="rista-sprite arrow-left-blue-big mr-[12px]"></div>
                <p className="text-14 font-medium text-black">Change Business</p>
              </div>
            )}
            <div
              className={`flex items-center w-full rounded-b-[8px] px-[20px] py-[16px] border-t border-[#DDDDDD] hover:bg-black/5 cursor-pointer`}
              onClick={() => setOpenLogoutPopup(true)}
            >
              <div className="rista-sprite ic-logout mr-[12px]"></div>
              <p className="text-14 font-medium text-black">Log Out</p>
            </div>
          </div>
        )}
      </div>
      {openLogoutPopup && (
        <ConfirmationModal
          onConfirmBtnClick={onLogoutClick}
          onModalClose={() => setOpenLogoutPopup(false)}
          headingText="Logout"
          description="Do you want to logout?"
        />
      )}
    </>
  );
};

export default AccountControlComponent;
